import { ReactNode } from 'react';

import { bodyClassName } from './styles';

interface Props {
  children: ReactNode;
}

const Body = ({ children }: Props) => {
  return (
    <div className={bodyClassName}>
      {children}
    </div>
  );
};

Body.displayName = 'Body';

export default Body;
